var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListBreadcrumbs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feather Icons / file-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.16732 1.16666H3.50065C3.19123 1.16666 2.89449 1.28958 2.67569 1.50837C2.4569 1.72717 2.33398 2.02391 2.33398 2.33333V11.6667C2.33398 11.9761 2.4569 12.2728 2.67569 12.4916C2.89449 12.7104 3.19123 12.8333 3.50065 12.8333H10.5007C10.8101 12.8333 11.1068 12.7104 11.3256 12.4916C11.5444 12.2728 11.6673 11.9761 11.6673 11.6667V4.66666L8.16732 1.16666Z",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.16602 1.16666V4.66666H11.666",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.33268 7.58334H4.66602",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.33268 9.91666H4.66602",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.83268 5.25H5.24935H4.66602",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListBreadcrumbs);
export default __webpack_public_path__ + "static/media/list_breadcrumbs.6c04229a99ca70645d20c17ad7ae25cc.svg";
export { ForwardRef as ReactComponent };